export enum IncidentGroupTypes {
    TraficoOParaLlegar = "TraficoOParaLlegar",
    MecanicoColision = "MecanicoColision",
    ConLaEntrega = "ConLaEntrega",
    ConLaMercancia = "ConLaMercancia",
    Otro = "Otro",
    None = "None"
}
